import { gql } from 'graphql-tag';

export const createBooking = gql`
  mutation(
    $userId: ID
    $preferredPartnerId: ID
    $firstName: String
    $lastName: String
    $email: String
    $phoneCountryCode: String
    $phoneDialCode: String
    $phoneNumber: String
    $ordersDetails: String
    $bookingType: Int
    $scheduleFrom: Int
    $categoryId: Int
    $location: String
    $lat: Float
    $lng: Float
  ) {
    createBooking(
      userId: $userId
      preferredPartnerId: $preferredPartnerId
      firstName: $firstName
      lastName: $lastName
      email: $email
      phoneCountryCode: $phoneCountryCode
      phoneDialCode: $phoneDialCode
      phoneNumber: $phoneNumber
      ordersDetails: $ordersDetails
      categoryId: $categoryId
      bookingType: $bookingType
      scheduleFrom: $scheduleFrom
      location: $location
      lat: $lat
      lng: $lng
    ) {
      result{
      id
      }
      status
      errorMessage
    }
  }
`;

export const updateScheduleBooking = gql`
  mutation(
    $bookingId : Int!
    $scheduleId: Int!
    $userId : String!
    $scheduleFrom: Int!
  ) {
    updateScheduleBooking(
    bookingId :$bookingId
    scheduleId: $scheduleId
    userId: $userId
    scheduleFrom: $scheduleFrom
    ) {
      status
      errorMessage
    }
  }
`;

export const getNearestPreferredPartner = gql`
  query getNearestPreferredPartner(
    $userId: String
    $subCategoryId: [Int]
    $searchList: String
    $lat: Float
    $lng: Float
  ) {
    getNearestPreferredPartner(
      userId: $userId
      subCategoryId: $subCategoryId
      searchList: $searchList
      lat: $lat
      lng: $lng
    ) {
      results {
        id
        phoneNumber
        phoneDialCode
        overallRating
        lat
        lng
        completedBookingCount
        profile {
          firstName
          picture
        }
      }
      status
      errorMessage
    }
  }
`;

export const getAllBookings = gql`
query getAllBookings($currentPage: Int, $searchList: String, $bookingType: Int,$isManualBooking: Boolean){
  getAllBookings(currentPage: $currentPage, searchList: $searchList, bookingType: $bookingType,isManualBooking: $isManualBooking){
   status
   count
   results{
        id
        userLocation
        currency
        status
        partnerDetails{
          encryptFirstName
          userData{
            encryptEmail
          }
        }
        userDetails{
          encryptFirstName
          userData{
            encryptEmail
          }
        }
        categoryDetails{
          name
        }
        totalRideDistance
        totalFare
        userPayableFare
        messageData{
          threadItemsCount
        }
    }
  }
}`;



export const createUserBooking = gql`mutation createUserBooking(
    $orderId: Int!
    $dropOffLocation: String
    $dropOffLat: Float 
    $dropOffLng: Float
    $requestCurrency: String
    $promoId: Int
    $reviewDescription: String
    $paymentType: Int
    $preferredPartnerId: String
  ) {
createUserBooking (
    orderId: $orderId
    dropOffLocation: $dropOffLocation
    dropOffLat: $dropOffLat
    dropOffLng: $dropOffLng
    requestCurrency: $requestCurrency
    promoId: $promoId
    reviewDescription: $reviewDescription
    paymentType: $paymentType
    preferredPartnerId:$preferredPartnerId
) {
    status
    errorMessage
    result{
        id
        name
        userId
        partnerId
        userLocation
        partnerLocation
        bookingId
        categoryId
        totalFare
        userTotalFare
        partnerTotalFare
        paymentType
        specialServiceTotalFare
    }
}
}`

export const getBookingById = gql`query getBookingById($bookingId: Int){
  getBookingById(bookingId: $bookingId){
   status
   result{
        id
        userLocation
        currency
        status
        userId
        partnerId
        startLocation
        startLat
        startLng
        endLocation
        endLat
        endLng
        pricingType
        bookingType
        paymentStatus
        paymentType
        additionalFeeStatus
        requestedAdditionalFee
        requestedAdditionalFeeDescription
        secondDifference
        additionalWorkInterval
        tipsAmount
        messageData{
          unreadThreadCount
        }
        isReviewPageVisited
        partnerDetails{
          firstName
          preferredLocation
          lat
          lng
          picture
          userData{
            email
            overallRating
            phoneNumber
            phoneDialCode
          }
        }
        userDetails{
          firstName
          userData{
            email
          }
        }
        bookingHistory{
          status
          createdAt
          id
        }
        orderItemsList{
            id
            categoryId
            subCategoryId
            orderId
            baseFare
            minimumHours
            currency
            totalQuantity
            workedDuration
            workDuration
            pausedDuration
            startedAt
            completedAt
            dropLocation
            dropLat
            dropLng
            multiplierValue
            subCategoryDetails{
              id
              name
              description
              image
              categoryId
              status
              pricingDetails{
                basePrice
              }
            }
            workLogHistory {
              id
              status
              closedAt
              startedAt
              totalDuration
              totalWork
            }
          }
        categoryDetails{
              id
              name
              status
              description
              bannerImage
              pricingType
        }
        totalRideDistance
        totalFare
        userPayableFare
        messageData{
          threadItemsCount
        }
    }
  }
}`;

export const cancelManualBooking = gql`mutation cancelManualBooking(
  $bookingId: Int!
  $reason: String
) {
cancelManualBooking (
  bookingId: $bookingId
  reason: $reason
) {
  status
  errorMessage
  result{
      id
      name
      userId
      partnerId
  }
}
}`

export const updateTips = gql`mutation updateTips(
  $bookingId: Int
  $currency: String
  $amount: Float
  $paymentType: Int
  $isUpdateTip:Boolean
) {
updateTips (
  bookingId: $bookingId
  currency: $currency
  amount: $amount
  paymentType: $paymentType
  isUpdateTip:$isUpdateTip
) {
  status
  errorMessage
}
}`


export const changePaymentType = gql`mutation changePaymentType(
  $bookingId: Int!
  $paymentType: Int!
) {
changePaymentType (
  bookingId: $bookingId
  paymentType: $paymentType
) {
  status
  errorMessage
}
}`

export const createScheduleBooking = gql`mutation createScheduleBooking(
  $orderId: Int!
  $dropOffLocation: String
  $dropOffLat: Float 
  $dropOffLng: Float
  $requestCurrency: String
  $promoId: Int
  $reviewDescription: String
  $paymentType: Int
  $scheduleFrom: Int!
) {
createScheduleBooking (
  orderId: $orderId
  dropOffLocation: $dropOffLocation
  dropOffLat: $dropOffLat
  dropOffLng: $dropOffLng
  requestCurrency: $requestCurrency
  promoId: $promoId
  reviewDescription: $reviewDescription
  paymentType: $paymentType
  scheduleFrom: $scheduleFrom
) {
  status
  errorMessage
  result{
      id
      name
      userId
      partnerId
      userLocation
      partnerLocation
      bookingId
      categoryId
      totalFare
      userTotalFare
      partnerTotalFare
      paymentType
      specialServiceTotalFare
  }
}
}`

export const cancelScheduleBooking = gql`mutation cancelScheduleBooking(
  $bookingId: Int!
) {
cancelScheduleBooking (
  bookingId: $bookingId
) {
  status
  errorMessage
}
}`

export const getAllBooking = gql`query getAllBooking($currentPage: Int, $requestType: String, $requestCurrency: String){
  getAllBooking(currentPage: $currentPage, requestType: $requestType, requestCurrency: $requestCurrency){
   status
   count
   results{
        id
        userLocation
        currency
        status
        pricingType
        createdAt
        partnerDetails{
          userId
          firstName
          userData{
            email
          }
        }
        userDetails{
          userId
          firstName
          userData{
            email
          }
        }
        categoryDetails{
          id
          name
          bannerImage
        }
        totalRideDistance
        totalFare
        userTotalFare
        userPayableFare
        startLocation
        endLocation
        bookingType
        status
        paymentStatus
        scheduleBooking{
          id
          scheduleFrom
        }
        messageData{
          threadItemsCount
        }
    }
  }
}
`

export const additionalFeeUserResponse = gql`mutation additionalFeeUserResponse(
  $bookingId: Int!
  $status: String
) {
additionalFeeUserResponse (
  bookingId: $bookingId
  status: $status
) {
  status
  errorMessage
}
}`